import { TenantProvider } from '../../auth/TenantContext';
import { UserAvatarProvider } from '../../auth/UserAvatarContext';
import { WorkspaceGate } from './WorkspaceGate';

/**
 * Authenticated agency layout. The sidebar + topbar chrome and the routed page
 * content are rendered by {@link WorkspaceGate}, which also gates the app until
 * the user has at least one Brand Workspace.
 */
export function AppShell() {
  return (
    <TenantProvider>
      <UserAvatarProvider>
        <WorkspaceGate />
      </UserAvatarProvider>
    </TenantProvider>
  );
}
